import { ITextField } from "cayo.ui";
import { IJsonForm } from "@cayo/shared/api/types/schema";
import { bitLockerFormFields } from "./constants";

const TEXT_FIELD = "text-field";

const { computerDns, fullDate, passwordID, recoveryGuid } = bitLockerFormFields;

export const bitLockerPasswordsForm: IJsonForm = {
  type: "json-form",
  layout: [
    {
      items: [computerDns.id, fullDate.id],
      justifyContent: "space-between",
      childrenGap: 6,
      type: "row",
      stretch: true,
    },
  ],
  items: [
    {
      name: recoveryGuid.id,
      id: recoveryGuid.id,
      label: recoveryGuid.label,
      copyEnabled: true,
      readOnly: true,
      renderInput: true,
      dataTestId: `${TEXT_FIELD}_${recoveryGuid.id}`,
      type: TEXT_FIELD,
    },
    {
      name: computerDns.id,
      id: computerDns.id,
      label: computerDns.label,
      copyEnabled: true,
      readOnly: true,
      renderInput: true,
      dataTestId: `${TEXT_FIELD}_${computerDns.id}`,
      type: TEXT_FIELD,
    },
    {
      name: fullDate.id,
      id: fullDate.id,
      label: fullDate.label,
      copyEnabled: true,
      readOnly: true,
      renderInput: true,
      dataTestId: `${TEXT_FIELD}_${fullDate.id}`,
      type: TEXT_FIELD,
    },
    {
      name: passwordID.id,
      id: passwordID.id,
      label: passwordID.label,
      copyEnabled: true,
      readOnly: true,
      renderInput: true,
      dataTestId: `${TEXT_FIELD}_${passwordID.id}`,
      type: TEXT_FIELD,
    },
  ] as ITextField[],
};
